import { PartnerPageMetric } from 'legacy/lut/configs/metrics'
import {
  fetchPartner360Configuration,
  IFetchPartnerInfoParams,
} from 'legacy/lut/services/partner360/configuration/fetchPartner360Configuration'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { measureRequest } from 'shared/lib/metrics'

import { YEAR_WHEN_GP_APPEARS } from '../../../globalPartner/constants'
import { REQUEST_PARTNER_DATA } from '../constants'
import { selectConfigurationLoadingStatus } from '../selectors/selectConfigurationLoadingStatus'

export const requestPartnerData = createAsyncThunk(
  REQUEST_PARTNER_DATA,
  (params: IFetchPartnerInfoParams, { getState }) =>
    measureRequest(PartnerPageMetric.JbpData, selectUser(getState()), () =>
      fetchPartner360Configuration(params)
    ),
  {
    condition({ partnerId, fYear }, { getState }) {
      if (!partnerId || !fYear) {
        return false
      }

      if (partnerId.startsWith('GP') && fYear < YEAR_WHEN_GP_APPEARS) {
        return false
      }

      const state = getState()
      const status = selectConfigurationLoadingStatus(state)
      if (status === RequestStatus.PENDING) {
        return false
      }

      return
    },
  }
)
